import { Form, Select, Input } from "antd";
import { TicketModel } from "models/tickets";
import { t } from "i18next";
import { Rule } from "antd/es/form";

interface SelectInputProps {
  selectInputValue?: string | null
  setSelectInputValue?: React.Dispatch<React.SetStateAction<any>>;
  ticket?: TicketModel;
  disabled?: boolean;
  rules?: Rule[];
}

const SelectInput = ({ticket, selectInputValue, setSelectInputValue, disabled = false, rules}: SelectInputProps) => {
  const callTimePreference = ticket?.call_time_preference;
  
  const shouldShowDatetimeInput =
  (selectInputValue === "specific_time" || selectInputValue === "خلال وقت محدد") || // to show the datetime when you create the request
  (selectInputValue === "" &&  ticket?.call_time_preference === "specific_time");// to show the datetime when you go to the ticketDetails

  return (
    <>
      <Form.Item name="call_time_preference" label={t("customer_contact_time")} rules={rules} style={{marginBottom: "20px"}}>
        <Select
          showSearch
          disabled={disabled}
          defaultValue={ticket?.call_time_preference ? callTimePreference: ""}
          onChange={(value) => setSelectInputValue?.(value)}
          options={[
            { 
              value: "immediately", 
              label: t("immediately") 
            },
            { 
              value: "specific_time", 
              label: t("specific_time")
            },
            { 
              value: "as_soon_as_possible", 
              label: t("as_soon_as_possible") 
            },
          ]}
        />
      </Form.Item>
      {shouldShowDatetimeInput ? (
      <Form.Item
        name="call_datetime"
        label={t("Determine_the_time")}
        style={{ marginBottom: "20px" }}
        initialValue={ticket?.call_datetime}
        rules={[
          {
            required: true,
            message: t("please_add_specific_time"),
          },
        ]}
      >
        <Input
          type="datetime-local"
          disabled={disabled}
          style={{ width: "100%", height: "32px" }}
          min={new Date().toISOString().slice(0, 16)}
        />
      </Form.Item>
    ): <></>}
    </>
  );
};

export default SelectInput;